export default {
  REGISTERED: 1,
  FIRST_ANSWER: 2,
  FIRST_SALE: 3,
};
